export * from './IconWellBlue';
